import { Component, Input, OnDestroy, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class VideoComponent implements OnDestroy {
    @ViewChild('video') audioPlayer!: ElementRef;

    @Input({ required: true }) backgroundImage!: string;
    @Input({ required: true }) videos!: string[];
    @Input({ required: true }) title!: string;
    @Input({ required: true }) btnText!: string;

    isPlaying?: boolean;

    playVideo() {
        this.isPlaying = true;
        if (this.audioPlayer) {
            return this.audioPlayer.nativeElement.play();
        }
    }

    videoEnded(): void {
        this.isPlaying = false;
    }

    ngOnDestroy(): void {
        if (this.audioPlayer) {
            this.audioPlayer.nativeElement.pause();
            this.audioPlayer.nativeElement.removeAttribute('src');
            this.audioPlayer.nativeElement.load();
        }
    }
}
